export default "__VITE_ASSET__45f5fc04__"